// extracted by mini-css-extract-plugin
export var active = "BurgerBtn-module--active--a6c5c";
export var button = "BurgerBtn-module--button--0037d";
export var fixed = "BurgerBtn-module--fixed--a5bd3";
export var light = "BurgerBtn-module--light--a8be5";